// extracted by mini-css-extract-plugin
module.exports = {"notFoundPage":"_404--notFoundPage--1vhss","header":"_404--header--1o2Tc"};